import React, { useState } from "react";
import "./styles.css";
//import { AiOutlineSearch } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import { Collapse } from "react-collapse";
import FormRIPacientesCadastro from './../../../components/Forms_RepresentanteDeInstituição/Tela_RI_Pacientes_Cadastro';
//import { NavLink } from 'react-router-dom';
import SideNav from './../../../components/SideNav_RI';

export default function RI_PacientesCadastro() {
    //let [search, setSearch] = useState(false);
    let [options, setOptions] = useState(false);

    return (
        <>
            <SideNav />
            <div id="top-RI-Cadastro"></div>
            <div id="main-RI-Detalhes-Paciente">
                <p id="RI-Detalhes-Paciente">Cadastro de pacientes</p> 
                <hr id="divider-RI-Detalhes-Paciente" />
                <FormRIPacientesCadastro />
            </div>
        </>
    );
}